// receving components
const Receiving = () => import("Modules/manufacturing/receiving/views/Receiving");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "receiving/:view?",
            name: "receiving",
            component: Receiving,
            meta: {
                requiresAuth: true,
                title: "lang.receiving",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["receiving.read"],
            },
        },
    ],
};
